import React from "react";
import Maps from "../../_components/Maps";

function DriverMaps() {
  return <Maps />;
}

export default DriverMaps;
